var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var LabourCostAPI = /** @class */ (function (_super) {
    __extends(LabourCostAPI, _super);
    function LabourCostAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabourCostAPI.prototype.list = function (props) { return this.fetchPaginated("/api/costing/labour/list", props); };
    LabourCostAPI.prototype.remove = function (props) { return this.fetcher.post("/api/costing/labour/remove", props); };
    LabourCostAPI.prototype.insert = function (props) { return this.fetcher.post("/api/costing/labour/create", props); };
    LabourCostAPI.prototype.update = function (props) { return this.fetcher.post("/api/costing/labour/update", props); };
    LabourCostAPI.prototype.utm = function () { return this.fetcher.get("/api/costing/labour/utm-list"); };
    LabourCostAPI.prototype.vendors = function () { return this.fetcher.get("/api/costing/labour/vendor-list"); };
    return LabourCostAPI;
}(SubAPI));
export { LabourCostAPI };
